// src/Components/Quran/BySurah/BySurah.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, Typography, Grid } from '@mui/material';

const BySurah = () => {
  const [surahs, setSurahs] = useState([]);

  useEffect(() => {
    const fetchSurahs = async () => {
      try {
        const response = await fetch('https://api.alquran.cloud/v1/surah');
        const data = await response.json();
        setSurahs(data.data);
      } catch (error) {
        console.error('Error fetching surahs:', error);
      }
    };

    fetchSurahs();
  }, []);

  return (
    <Grid style={{ marginTop: '10px' }} container spacing={2}>
      {surahs.map((surah) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={surah.number}>
          <Link to={`/surah/${surah.number}`} style={{ textDecoration: 'none' }}>
            <Card style={{ backgroundColor: 'darkslategray', marginLeft: '5px', marginRight: '5px', height: '180px' }}>
              <CardContent>
                <Typography variant="h4" sx={{ color: 'gold' }} component="div">
                  {surah.name}
                </Typography>
                <Typography variant="h6" sx={{ color: 'goldenrod', fontFamily: 'Cinzel Decorative' }} gutterBottom>
                  {surah.englishName}
                </Typography>
                <Typography color="text.secondary" style={{ color: 'whitesmoke', fontFamily: 'OpenSans' }}>
                  <strong style={{ color: 'gold' }}>Total Verses:</strong> {surah.numberOfAyahs}
                </Typography>
                <Typography color="text.secondary" sx={{ color: 'whitesmoke', fontFamily: 'OpenSans' }}>
                  <strong style={{ color: 'gold' }}>Surah Number:</strong> {surah.number}
                </Typography>
                <Typography color="text.secondary" sx={{ color: 'whitesmoke', fontFamily: 'OpenSans' }}>
                  <strong style={{ color: 'gold' }}>Revelation Type:</strong> {surah.revelationType}
                </Typography>
              </CardContent>
            </Card>
          </Link>
        </Grid>
      ))}
    </Grid>
  );
};

export default BySurah;
